import { Component } from '@angular/core';

@Component({
  selector: 'uni-nav-name',
  templateUrl: './uni-nav-name.component.html',
  styleUrls: ['./uni-nav-name.component.scss']
})
export class UniNavNameComponent {}
